module.exports = __webpack_public_path__ + "img/logo-xpress.8d5053d5.png";